import { IApplicationState } from '../../../types/types';
import { ERoutes } from '../constants';

export const isIndex = (
    state: IApplicationState
): boolean => {
    const { route } = state.router;
    return route === ERoutes.INDEX;
}
